// // src/pages/TermsAndConditions.jsx

// import "../css/Terms.css";
// import Footerlanding from '../landing/Footerlanding';
// import Navbarlanding from '../landing/Navbarlanding';

//     const TermsAndConditions = () => {
//     return (
//         <div className="terms-page">
//         <Navbarlanding />

//         <div className="terms-wrapper">
//             <h1>Terms &amp; Conditions</h1>
//             <p>Last updated: [Date]</p>

//             <section>
//             <h2>1. Introduction</h2>
//             <p>
//                 Welcome to Techvision (“we”, “us”, “our”). These Terms &amp;
//                 Conditions govern your access to and use of our website and
//                 services. By accessing or using our website, you agree to these
//                 Terms &amp; Conditions. If you do not agree, please do not use our
//                 services.
//             </p>
//             </section>

//             <section>
//             <h2>2. Definitions</h2>
//             <p>
//                 <strong>“Service”</strong> refers to our website and any
//                 services provided through it. <br />
//                 <strong>“User”</strong> means any person accessing or using the
//                 Service. <br />
//                 <strong>“Content”</strong> includes text, images, videos, links,
//                 and any other material provided on our Service.
//             </p>
//             </section>

//             <section>
//             <h2>3. Use of the Service</h2>
//             <p>
//                 You agree to use the Service only for lawful purposes, and in a
//                 manner consistent with these Terms and applicable laws. You
//                 further agree not to:
//             </p>
//             <ul>
//                 <li>Use the Service in violation of any applicable law or regulation</li>
//                 <li>Attempt to gain unauthorized access to any part or feature of the Service</li>
//                 <li>Interfere with or disrupt the Service or servers or networks</li>
//                 <li>Use any robot, spider, crawler, or other automated means to access the Service</li>
//             </ul>
//             </section>

//             <section>
//             <h2>4. Account Registration (if applicable)</h2>
//             <p>
//                 Some parts of the Service may require you to register an account.
//                 You are responsible for maintaining the confidentiality of your
//                 account credentials and for all activities that occur under your
//                 account. You must notify us immediately if your credentials are
//                 compromised.
//             </p>
//             </section>

//             <section>
//             <h2>5. Intellectual Property</h2>
//             <p>
//                 All content, trademarks, logos, and materials on the Service are
//                 owned by or licensed to Techvision and are protected by
//                 intellectual property laws. You may not copy, reproduce,
//                 distribute, or create derivative works of any content without our
//                 prior written permission.
//             </p>
//             </section>

//             <section>
//             <h2>6. Disclaimer of Warranties</h2>
//             <p>
//                 The Service is provided “as is” and “as available.” We make no
//                 warranties, express or implied, including warranties of
//                 merchantability, fitness for a particular purpose, or
//                 non-infringement. We do not guarantee continuous, uninterrupted,
//                 or error-free access to the Service.
//             </p>
//             </section>

//             <section>
//             <h2>7. Limitation of Liability</h2>
//             <p>
//                 To the fullest extent permitted by law, Techvision is not liable
//                 for any indirect, incidental, special, consequential, or punitive
//                 damages arising out of your use of the Service. Our total
//                 liability to you is limited to the amount you paid (if any) to us.
//             </p>
//             </section>

//             <section>
//             <h2>8. Indemnification</h2>
//             <p>
//                 You agree to indemnify, defend, and hold harmless Techvision and
//                 its officers, directors, employees, and agents from all claims,
//                 damages, losses, liabilities, and costs (including legal fees)
//                 arising out of or related to (a) your use of the Service, (b)
//                 violation of these Terms, or (c) violation of any rights of a
//                 third party.
//             </p>
//             </section>

//             <section>
//             <h2>9. Modifications to Terms</h2>
//             <p>
//                 We reserve the right to modify these Terms &amp; Conditions at any
//                 time. Changes become effective upon posting the updated Terms on
//                 this page. Your continued use after changes indicates acceptance
//                 of the new terms.
//             </p>
//             </section>

//             <section>
//             <h2>10. Governing Law & Jurisdiction</h2>
//             <p>
//                 These Terms shall be governed by and construed in accordance with
//                 the laws of [State / Country], without regard to its conflict of
//                 law principles. All disputes arising shall be subject to the
//                 exclusive jurisdiction of courts in [City / State].
//             </p>
//             </section>

//             <section>
//             <h2>11. Contact Information</h2>
//             <p>
//                 If you have any questions or concerns regarding these Terms &
//                 Conditions, you may contact us at: <br />
//                 Email: info@yourdomain.com <br />
//                 Address: Your Company Address
//             </p>
//             </section>
//         </div>

//         <Footerlanding />
//         </div>
//     );
//     };

//     export default TermsAndConditions;


import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/Terms.css";
import Footerlanding from "../landing/Footerlanding";
import Navbarlanding from "../landing/Navbarlanding";
import { parse } from "tldts";

const TermsAndConditions = () => {
  const [company, setCompany] = useState({
    name: "Your Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    email: "",
  });
  const [fetchError, setFetchError] = useState("");

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
            domain: data.domain || prev.domain,
            subdomain: data.subdomain || prev.subdomain,
            email: data.email || prev.email,
          }));

          if (data.favicon) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${
              data.favicon.startsWith("images/")
                ? data.favicon.slice(7)
                : data.favicon
            }`;
            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
        setFetchError("Failed to fetch company info.");
      }
    };

    fetchCompany();
  }, []);

  const supportEmail = company?.email || "support@yourdomain.com";
const contactEmail = company?.email || "contact@yourdomain.com";

  return (
    <div className="terms-page">
      <Navbarlanding />

      <div className="terms-wrapper">
        <h1>Terms & Conditions – {company.name}</h1>
        <p className="last-updated">Effective Date: January 2026</p>

        {fetchError && <p className="error-text">{fetchError}</p>}

        <section>
          <p>
            Welcome to {company.name} ({company.domain || "yourdomain.com"}).
          </p>
          <p>
            These Terms & Conditions (“Terms”) govern your access to and use of
            our website and digital banking software platform. By accessing or
            using our services, you agree to be bound by these Terms.
          </p>
          <p>
            If you do not agree with any part of these Terms, you must not use
            our services.
          </p>
        </section>

        <section>
          <h2>1. Definitions</h2>
          <p>
            <strong>“Platform”</strong> refers to the website{" "}
            {company.domain || "yourdomain.com"} and its digital services.
            <br />
            <strong>“User”</strong> refers to any individual or entity accessing
            or using the platform.
            <br />
            <strong>“{company.name}”, “we”, “our”, “us”</strong> refers to the
            owners and operators of the platform.
            <br />
            <strong>“Services”</strong> include digital banking software services
            such as account facilitation, virtual accounts, and loan application
            support.
          </p>
        </section>

        <section>
          <h2>2. Nature of Services</h2>
          <p>{company.name} is a digital banking software platform that facilitates:</p>
          <ul>
            <li>Savings, RD, and FD account-related services</li>
            <li>Virtual account solutions</li>
            <li>
              Loan application support including Group Loan, Personal Loan,
              Instant Loan, and Small Business Loan
            </li>
          </ul>
          <p>
            {company.name} does not act as a bank or financial institution, and
            all approvals are subject to the policies and eligibility criteria
            of respective financial partners.
          </p>
        </section>

        <section>
          <h2>3. Eligibility</h2>
          <p>To use our services, you must:</p>
          <ul>
            <li>Be at least 18 years of age</li>
            <li>Provide accurate, complete, and up-to-date information</li>
            <li>Have legal capacity to enter into a binding agreement</li>
          </ul>
          <p>
            {company.name} reserves the right to deny access to users who do not
            meet eligibility requirements.
          </p>
        </section>

        <section>
          <h2>4. User Responsibilities</h2>
          <p>Users agree to:</p>
          <ul>
            <li>Provide true and accurate information during registration and applications</li>
            <li>Maintain confidentiality of login credentials</li>
            <li>
              Immediately notify {company.name} of any unauthorized access or
              security breach
            </li>
            <li>Use the platform only for lawful purposes</li>
          </ul>
          <p>
            {company.name} shall not be responsible for losses arising from user
            negligence.
          </p>
        </section>

        <section>
          <h2>5. Account Registration & Security</h2>
          <ul>
            <li>Users are responsible for all activities under their account</li>
            <li>Sharing of login credentials is strictly prohibited</li>
            <li>
              {company.name} may suspend or terminate accounts suspected of
              misuse or fraud
            </li>
          </ul>
        </section>

        <section>
          <h2>6. Applications & Approvals</h2>
          <ul>
            <li>All account and loan applications are subject to verification and approval</li>
            <li>Submission of an application does not guarantee approval</li>
            <li>
              Approval timelines depend on partner institutions and regulatory
              processes
            </li>
          </ul>
        </section>

        <section>
          <h2>7. Fees & Charges</h2>
          <ul>
            <li>Any applicable fees or service charges will be disclosed prior to processing</li>
            <li>{company.name} reserves the right to revise fees with or without prior notice</li>
          </ul>
        </section>

        <section>
          <h2>8. Intellectual Property Rights</h2>
          <p>
            All content on {company.domain || "yourdomain.com"}, including text,
            graphics, logos, and software, is the intellectual property of{" "}
            {company.name} and protected under applicable laws. Unauthorized
            use, reproduction, or distribution is strictly prohibited.
          </p>
        </section>

        <section>
          <h2>9. Prohibited Activities</h2>
          <p>Users must not:</p>
          <ul>
            <li>Engage in fraudulent or misleading activities</li>
            <li>Attempt to access unauthorized systems or data</li>
            <li>Upload harmful code or malware</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
          <p>Violation may result in immediate termination of access.</p>
        </section>

        <section>
          <h2>10. Limitation of Liability</h2>
          <p>{company.name} shall not be liable for:</p>
          <ul>
            <li>Any indirect, incidental, or consequential damages</li>
            <li>Losses arising from service interruptions or technical issues</li>
            <li>
              Decisions taken by financial partners regarding approvals or
              rejections
            </li>
          </ul>
          <p>Use of the platform is at the user’s own risk.</p>
        </section>

        <section>
          <h2>11. Third-Party Services</h2>
          <p>
            {company.name} may integrate or link to third-party services. We are
            not responsible for the content, actions, or policies of third
            parties.
          </p>
        </section>

        <section>
          <h2>12. Termination</h2>
          <p>{company.name} reserves the right to:</p>
          <ul>
            <li>Suspend or terminate user access without prior notice</li>
            <li>Take necessary legal action in case of violation of these Terms</li>
          </ul>
        </section>

        <section>
          <h2>13. Governing Law & Jurisdiction</h2>
          <p>
            These Terms shall be governed by and interpreted in accordance with
            the laws of India. All disputes shall be subject to the exclusive
            jurisdiction of Indian courts.
          </p>
        </section>

        <section>
          <h2>14. Amendments</h2>
          <p>
            {company.name} may update these Terms & Conditions at any time.
            Continued use of the platform constitutes acceptance of the revised
            Terms.
          </p>
        </section>

        <section>
          <h2>15. Contact Information</h2>
          <p>
            For any questions regarding these Terms & Conditions, please contact:
          </p>
          <p>
            {/* 📧 <a href={`mailto:${supportEmail}`}>{supportEmail}</a> <br /> */}
            📧 <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
               
          </p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>
            {company.name} is a digital banking software platform and does not
            provide banking or lending services directly. All services are
            subject to eligibility, verification, and approvals by authorized
            financial partners.
          </p>
        </section>
      </div>

      <Footerlanding />
    </div>
  );
};

export default TermsAndConditions;
